import React from "react";
import { FormProvider } from "react-hook-form";
import { Create } from "@refinedev/mui";

import { BookForm } from "@modules/books/components/BookForm";
import { useBookCreateForm } from "./controller";

export const BookCreate = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending } = useBookCreateForm();

  return (
    <Create
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
    >
      <FormProvider {...methods}>
        <BookForm />
      </FormProvider>
    </Create>
  );
});
